import { render } from "./ConfAccessi.vue?vue&type=template&id=4bb3d4e6"
import script from "./ConfAccessi.vue?vue&type=script&lang=js"
export * from "./ConfAccessi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__